"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const emailRouter = {
  path: '/email',
  component: _index.default,
  redirect: 'noredirect',
  name: 'Email Management',
  meta: {
    title: 'emailManagement.title',
    icon: 'email',
    roles: ['Super Admin', 'Admin', 'System Admin'] // optional if using roles
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "email-list" */
    '@/views/email/list.vue'))),
    name: 'EmailList',
    meta: {
      title: 'emailManagement.email.title',
      icon: 'email',
      noCache: true
    }
  }, {
    path: 'view/:id',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require(/* webpackChunkName: "email-view" */
    '@/views/email/components/EmailDetails.vue'))),
    name: 'EmailDetails',
    meta: {
      title: 'Email Details',
      activeMenu: '/email/list',
      hidden: true
    }
  }
  // {
  //   path: 'compose',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "email-compose" */
  //       '@/views/email/manage.vue'
  //     ),
  //   name: 'ComposeEmail',
  //   meta: {
  //     title: 'Compose'
  //   }
  // }
  ]
};
var _default = exports.default = emailRouter;